/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { useState } from "react";
import General from "./General";
import Radius from "./Radius";
import Saml from "./Saml";
import Tacacs from "./Tacacs";

const groupList = [
  { id: 0, label: "GENERAL", component: <General /> },
  { id: 1, label: "RADIUS", component: <Radius /> },
  { id: 2, label: "TACACS+", component: <Tacacs /> },
  { id: 3, label: "SAML", component: <Saml /> },
];

const AuthenticationGroupList: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="flex items-start gap-5 pt-4">
      {/* Left Menu */}
      <aside
        style={{
          backgroundColor: "var(--left-Navigation-background)",
          marginLeft: "11px",
        }}
        className="w-52 shrink-0 rounded-lg border border-border/80 overflow-hidden flex flex-col max-h-[calc(100vh-12rem)] self-start">
        <div className="p-3 border-b border-border/80 bg-muted/20">
          <div className="flex items-center justify-between gap-2">
            <h1 className="text-sm font-semibold text-foreground truncate m-0 ml-1">
              Authentication
            </h1>
          </div>
        </div>
        <nav className="p-2 flex-1 min-h-0 overflow-y-auto">
          {groupList.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setSelectedIndex(item.id)}
              className={`w-full flex items-center justify-between gap-2 px-2.5 py-2 text-left text-sm transition-colors border-0 rounded-md ${
                selectedIndex === item.id
                  ? 'bg-[var(--left-Navigation-selected-background)] text-accent-foreground font-medium'
                  : 'bg-transparent hover:bg-[var(--left-Navigation-hover-background)] text-foreground'
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </aside>
      {/* Right Content */}
      <div className="flex-1 min-w-0 ml-1" style={{paddingRight: "10px"}}>
        {groupList[selectedIndex].component}
      </div>
    </div>
  );
};

export default AuthenticationGroupList;
